export const searchInputInitialValues = {
  search: { filter: 'kardex.employeeNumber' },
};

export const searchFilters = [
  { value: 'user.name', label: 'Médico' },
  { value: 'kardex.employeeNumber', label: 'No. de empleado' },
];

export const searchFiltersCosmetology = [
  { value: 'user.name', label: 'Cosmetóloga' },
  { value: 'kardex.employeeNumber', label: 'No. de empleado' },
];

export const filters = {
  search: true,
  branches: true,
  fortnightly: true,
};

export const filtersMedical = {
  dates: true,
};

export const filtersCosm = {
  fortnightly: true,
};

export const filterNoApprove = {
  search: true,
  fortnightly: true,
};

export const salesConst = {
  DETAIL: 'Detalle',
};

export const commissionType = {
  MEDICAL: 'Médica',
  COSMETOLOGIC: 'Cosmetológica',
};

export const commissionConst = {
  MEDICAL_MODAL_TITLE: 'Comisiones médicas',
  COSMETOLOGY_MODAL_TITLE: 'Comisiones cosmetológicas',
  COMMISSION_AGENT_UPDATE: 'Actualizar comisionista',
  TOTAL_COMMISSION: 'Total comisión',
  TOTAL_SALES: 'Total ventas',
};

export const commissionError = {
  MIN_LESS_THAN_MAX: 'El máximo debe ser mayor que el mínimo',
};
